import { render, staticRenderFns } from "./PropertyImageCardNew.vue?vue&type=template&id=01a04414&scoped=true"
import script from "./PropertyImageCardNew.vue?vue&type=script&lang=js"
export * from "./PropertyImageCardNew.vue?vue&type=script&lang=js"
import style0 from "./PropertyImageCardNew.vue?vue&type=style&index=0&id=01a04414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a04414",
  null
  
)

export default component.exports